/* Pearled Ivory — reviews overlay stacking fix.
   The custom #pi-reviews-overlay is rendered inside the sticky <product-info>
   column; position:sticky creates a stacking context that traps the overlay's
   position:fixed, letting the product image paint over its left half. Moving the
   overlay to <body> restores correct full-screen centering. Additive + reversible. */
(function () {
  function moveOverlay() {
    var ov = document.getElementById('pi-reviews-overlay');
    if (ov && ov.parentNode !== document.body) {
      document.body.appendChild(ov);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveOverlay);
  } else {
    moveOverlay();
  }
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('#pi-rating')) {
      setTimeout(moveOverlay, 0);
    }
  }, true);
})();
